import { SharedModule } from '../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProfileRoutingModule } from './profile.routing';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { PostEffects } from '../../shared/ui/post/data/store/effects';
import { ProfileInfoEffects } from './info/store/info.effects';
import { postsFeatureKey } from '../../shared/ui/post/data/store/state';
import { postsReducer } from '../../shared/ui/post/data/store/reducer';
import { ProfileComponent } from './profile.component';
import { ProfileSuggestionsComponent } from './suggestions/suggestions.component';
import { ProfileInfoComponent } from './info/info.component';
import { ProfilePostsComponent } from './posts/posts.component';
import {
  suggestionsReducer,
  suggestionsKey
} from './suggestions/store/suggestions.reducer';
import { SuggestionsEffects } from './suggestions/store/suggestions.effects';
import { profileKey, profileReducer } from './info/store/info.reducer';

@NgModule({
  declarations: [
    ProfileComponent,
    ProfileSuggestionsComponent,
    ProfileInfoComponent,
    ProfilePostsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ProfileRoutingModule,
    StoreModule.forFeature(postsFeatureKey, postsReducer),
    StoreModule.forFeature(profileKey, profileReducer),
    StoreModule.forFeature(suggestionsKey, suggestionsReducer),
    EffectsModule.forFeature([
      PostEffects,
      ProfileInfoEffects,
      SuggestionsEffects
    ])
  ]
})
export class ProfileModule {}
